import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 mb-10" }
const _hoisted_4 = { class: "card border-0 shadow-sm" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark" }, "Détails du postulant", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow me-2" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_10 = {
  key: 1,
  class: "text-center text-muted"
}
const _hoisted_11 = {
  key: 2,
  class: "row"
}
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-semibold mb-3" }, "Informations personnelles", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Nom :", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Prénom :", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "Email :", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "Téléphone :", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Sexe :", -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-semibold mb-3" }, "Profil professionnel", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Qualification :", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", null, "Expérience :", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "Date candidature :", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("strong", null, "Statut :", -1)
const _hoisted_25 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_26 = {
  key: 1,
  class: "badge bg-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_router_link, {
                to: "/liste-offres",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode("Retour ")
                ]),
                _: 1
              })
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Chargement..."))
              : (!_ctx.candidater)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Aucune donnée trouvée. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("p", null, [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_ctx.candidater.user?.nom), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.candidater.user?.prenom), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(_ctx.candidater.user?.email), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(_ctx.candidater.user?.telephone || "Non renseigné"), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_18,
                        _createTextVNode(" " + _toDisplayString(_ctx.candidater.user?.sexe || "Non renseigné"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("p", null, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.candidater.user?.qualification?.libelle || "Non spécifiée"), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_22,
                        _createTextVNode(" " + _toDisplayString(_ctx.candidater.user?.anneeExperience || 0) + " ans", 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_23,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.candidater.dateCandidature)), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_24,
                        (_ctx.candidater.estSelectionner)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Sélectionné"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_26, "Non sélectionné"))
                      ])
                    ])
                  ]))
          ])
        ])
      ])
    ])
  ]))
}